require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-aperam-brazil.json") })
        }
      }, "path---en-us-project-aperam-brazil");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-aperam-brazil!./.cache/json/en-us-project-aperam-brazil.json
// module id = 491
// module chunks = 231608221292675